import { supabase } from '@/integrations/supabase/client';

export const triggerCompanyDeepResearch = async (companyId: string): Promise<boolean> => {
  try {
    console.log('[CompanyEnrichment] Triggering deep research for company:', companyId);
    
    // Update status to processing
    await supabase
      .from('companies')
      .update({ 
        deep_research_status: 'processing',
        deep_research_updated_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      } as any)
      .eq('id', companyId);

    // Fire-and-forget: don't await so the UI can update immediately
    supabase.functions.invoke('deep-research-company', {
      body: { companyId }
    }).then(({ error }) => {
      if (error) {
        console.error('[CompanyEnrichment] Deep research failed:', error);
        supabase.from('companies').update({ 
          deep_research_status: 'failed',
          updated_at: new Date().toISOString()
        } as any).eq('id', companyId);
      }
    });

    return true;
  } catch (err) {
    console.error('[CompanyEnrichment] Deep research error:', err);
    return false;
  }
};

export const triggerCompanyCrawl = async (companyId: string): Promise<boolean> => {
  try {
    console.log('[CompanyEnrichment] Triggering crawl for company:', companyId);
    
    await supabase
      .from('companies')
      .update({ 
        crawl_status: 'processing',
        crawl_updated_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      } as any)
      .eq('id', companyId);

    // Fire-and-forget: don't await so the UI can update immediately
    supabase.functions.invoke('firecrawl-crawl-company', {
      body: { companyId }
    }).then(({ error }) => {
      if (error) {
        console.error('[CompanyEnrichment] Crawl failed:', error);
        supabase.from('companies').update({ 
          crawl_status: 'failed',
          updated_at: new Date().toISOString()
        } as any).eq('id', companyId);
      }
    });

    return true;
  } catch (err) {
    console.error('[CompanyEnrichment] Crawl error:', err);
    return false;
  }
};

export const getCompanyDeepResearchStatus = async (companyId: string): Promise<string | null> => {
  const { data } = await supabase
    .from('companies')
    .select('deep_research_status')
    .eq('id', companyId)
    .single();
  return (data as any)?.deep_research_status || null;
};

export const getCompanyCrawlStatus = async (companyId: string): Promise<string | null> => {
  const { data } = await supabase
    .from('companies')
    .select('crawl_status')
    .eq('id', companyId)
    .single();
  return (data as any)?.crawl_status || null;
};
